import { CheckboxButton } from './checkbox-button'
import { checkboxClassName } from './checkbox.styles'
import { CheckboxProps } from './checkbox.types'

export const Checkbox = ({ label, error, variant, fillBgWhenChecked, ...props }: CheckboxProps) => {
  const {
    container,
    label: labelClassName,
    defaultLabel,
    errorMessage,
  } = checkboxClassName({
    variant,
    fillBgWhenChecked,
    checked: props.checked,
    disabled: props.disabled,
    hasId: !!props.id,
  })

  const renderInput = () => {
    if (variant === 'outlined') {
      return (
        <label
          htmlFor={props.id}
          className={container()}
        >
          <CheckboxButton {...props} />
          {label && <span className={labelClassName()}>{label}</span>}
        </label>
      )
    }

    return (
      <div className={container()}>
        <CheckboxButton {...props} />
        {label && (
          <label
            htmlFor={props.id}
            className={defaultLabel()}
          >
            <span className={labelClassName()}>{label}</span>
          </label>
        )}
      </div>
    )
  }

  return (
    <div>
      {renderInput()}
      {error && <span className={errorMessage()}>{error}</span>}
    </div>
  )
}
